module.exports = __webpack_public_path__ + "static/media/back-arrow.04dd89e4.svg";